// React
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { Form, Modal, Spinner, Table } from "react-bootstrap";

// Tools
import {
  errorSwal,
  successDeleteSwal,
  successSwal,
  successUpdateSwal,
} from "../../../helper/sweetalert";
// import moment from "moment";
import { Formik } from "formik";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";

// Icons
import EditIcon from "@mui/icons-material/Edit";
// import ForumIcon from "@mui/icons-material/Forum";
import DeleteIcon from "@mui/icons-material/Delete";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';


// Apollo
import { GET_PRESIGN_URL } from "../../../apollo/presignUrl/query";
import { useLazyQuery, useMutation } from "@apollo/client";
import { S3_URL, USER_KEY } from "../../../const";
import { GET_BANKS } from "../../../apollo/bank/query";
import {
  CREATE_BANK,
  DELETE_BANK,
  UPDATE_BANK,
} from "../../../apollo/bank/mutation";

// Components
// import ConfirmDelete from "../../../components/ConfirmDelete";
import CustomButton from "../../../components/CustomButton";
import AnimationLoading from "../../../components/Animationloading";
import EmptyComponent from "../../../components/EmptyComponent";
import ComfirmModal from "../../../components/ComfirmModal";

function BankAccount() {
  const history = useHistory();
  const shopId = JSON.parse(localStorage.getItem(USER_KEY))?.data?.shop?.id;

  // ==========> useLaztQuery And useMutation <==========
  const [getBank, { data: getbankData, loading }] = useLazyQuery(GET_BANKS, { fetchPolicy: "cache-and-network", });
  const [getPresignUrl, { data: presignUrlData }] = useLazyQuery(GET_PRESIGN_URL);
  const [createBank, { loading: loadingCreate }] = useMutation(CREATE_BANK);
  const [deleteBank, { loading: loadingDelete }] = useMutation(DELETE_BANK);
  const [updateBank, { loading: loadingUpdate }] = useMutation(UPDATE_BANK);

  // ==========> modal Add <==========
  const [showAddAccount, setShowAddAccount] = useState(false);
  const [file, setFile] = useState();

  // ==========> isEdit for edit bank function <==========
  const [isEdit, setIsEdit] = useState(false);
  const [editIndex, setEditIndex] = useState();
  const [editData, setEditData] = useState({});
  const [userAccount, setuserAccount] = useState();


  // Image sourc
  const [imageLoading, setImageLoading] = useState(0);
  const [fileName, setFileName] = useState();

  // ==========> Delete state for edit bank function <==========
  const [showDelete, setShowDelete] = useState(false);
  const [Delete, setDelete] = useState("");

  // ==================================> useEffect <====================================
  useEffect(() => {
    if (getbankData) {
      setuserAccount(getbankData?.banks?.data);
    }
  }, [getbankData]);

  // console.log("delete:::::", Delete);


  useEffect(() => {
    // console.log("presignUrlData: ", presignUrlData);
    if (presignUrlData?.preSignedUrl?.url) {
      onFileUpload(presignUrlData?.preSignedUrl?.url);
    }
  }, [presignUrlData]);


  useEffect(() => {
    _fetchBank();
  }, [shopId]);

  // ===================> Fetch Data from bank <=====================
  const _fetchBank = async () => {
    try {
      if(loading) return;
      if (!shopId) {
        errorSwal("ບໍ່ພົບຂໍ້ມູນຮ້ານ");
        return;
      }
      await getBank({
        variables: {
          limit: 100,
          orderBy: "createdAt_DESC",
          where: {
            shop: shopId,
            isDeleted: false,
          },
        },
      });
    } catch (error) {
      console.log("Error in _fetchBank: ", error);
      if (!shopId) {
        errorSwal("ບໍ່ພົບຂໍ້ມູນຮ້ານ");
        return;
      }
    }
  };

  // ===============> Function create new bank Account <==================
  const _createBank = async (values) => {
    // console.log({ values });
    if (!values.bankAccount) {
      errorSwal("ກະລຸນາເພີ່ມຊື່...");
      return;
    }
    try {
      if (loadingCreate) return;
      await createBank({
        variables: {
          orderBy: "createdAt_DESC",
          data: {
            ...values,
            image: fileName,
          },
        },
      });
      _fetchBank();
      successSwal("ເພີ່ມສຳເລັດ");
      setShowAddAccount(false);
      setFile()
    } catch (err) {
      errorSwal("ຜູ້ໃຊ້ນີ້ມີຢູ່ແລ້ວ");
    }
  };


  // ================> Delete Bank <====================
  const handleShowDelete = (id, bankAccount) => {
    setDelete({ bankAccount, id });
    setShowDelete(true);
    // console.log("delte:::", Delete);
  };
  const _confirmeDelete = async () => {
    try {
      if (loadingDelete) return;
      await deleteBank({
        variables: {
          where: {
            id: Delete.id,
          },
        },
      });

      _fetchBank();
      successDeleteSwal("ລົບສຳເລັດ");
      setShowDelete(false);
    } catch (err) {
      errorSwal("ການລົບຂໍ້ມູນບໍ່ສຳເລັດ !");
    }
  };

  // ==============> Update Bank <=================
  const _updateBank = async () => {
    try {
      if (loadingUpdate) return;
      await updateBank({
        variables: {
          orderBy: "createdAt_DESC",
          where: {
            id: editData?.id,
          },
          data: {
            bankName: editData?.bankName,
            bankAccount: editData?.bankAccount,
            bankUser: editData?.bankUser,
            image: fileName || editData?.image,
            isActiveDefault: editData?.isActiveDefault,
          },
        },
      });

      setIsEdit(false);
      setFile()
      setEditIndex();
      setEditData({});
      successUpdateSwal("ເເກ້ໄຂຂໍ້ມູນສຳເລັດ");
      _fetchBank();
    } catch (err) {
      errorSwal("ລາຍການສິນຄ້ານີ້ມີຢູ່ແລ້ວ");
    }
  };

  // ================ Edit state in box ========----
  const onEditData = async (data, index) => {
    setIsEdit(true);
    setEditIndex(index);
    setEditData(data);
  };

  const onCancelEditData = async () => {
    setIsEdit(false);
    setEditIndex();
    setEditData({});
  };

  // ===============> Image editing <================
  const ImageThumb = ({ image }) => {
    return (
      <img
        src={URL.createObjectURL(image)}
        alt={image.name}
        style={{
          objectFit: "contain",
          borderRadius: 8,
          width: "100%",
        }}
      />
    );
  };
  // ===================> Fuction Upload Image <======================
  const handleUpload = async (event) => {
    setImageLoading(0);
    try {
      setFile(event.target.files[0]);
      var ext = event.target.files[0].name.split(".").pop();
      let filename = uuidv4() + "." + ext;
      const pre = await getPresignUrl({
        variables: {
          name: filename,
        },
      });
      setFileName(filename);
    } catch (error) {
      console.log(error);
    }
  };

  const onFileUpload = async (url) => {
    try {
      if (file && url) {
        const uploadfile = await axios.put(url, file, {
          headers: {
            "Content-Type": "file/*; image/*",
            Accept: "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
            "Access-Control-Allow-Headers":
              "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
          },
        });
      }
    } catch (error) {
      console.log("ERROR: ", error);
    }
  };

  return (
    <div className="bank-account-manage">
      <div className="bank-account-nav">
        <p
          className="p-profile"
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => history.goBack()}
        >
          ຕັ້ງຄ່າ
        </p>
        <p className="p-profile">/</p>
        <p className="p-profile">ບັນຊີທະນາຄານ</p>
      </div>
      <div className="bank-account-header">
        <h2 style={{ color: "rgba(107, 114, 128, 1)" }}>
          {" "}
          <AccountBalanceWalletIcon sx={{ fontSize: "3rem" }} /> ຕັ້ງຄ່າບັນຊີທະນາຄານ
        </h2>
        <CustomButton
          width="149px"
          height="42px"
          margin="0"
          title="ເພີ່ມບັນຊີທະນະຄານ"
          borderRadius="8px"
          background="rgb(60, 22, 155)"
          color="white"
          onClick={() => setShowAddAccount(true)}
        />
      </div>

      {/* Start Table */}
      {(loading && !getbankData) && <AnimationLoading />}
      {
        userAccount?.length > 0 ? <Table
          style={{
            marginTop: "20px",
            borderCollapse: "collapse",
            width: "100% ",
          }}
        >
          <thead
            style={{
              borderRadius: " 8px 8px 0px 0px",
              borderTop: "1px solid black",
              borderColor: "inherit",
            }}
          >
            <tr>
              <th style={{ paddingTop: "1rem" }}></th>
              <th>ລ/ດ</th>
              <th>ຮູບ QR</th>
              <th>ທະນະຄານ</th>
              <th>ເລກບັນຊີ</th>
              <th>ຊື່ບັນຊີ</th>
              <th>ຄ່າເລີ່ມຕົ້ນ</th>
              <th>ຈັດການ</th>
            </tr>
          </thead>
          <tbody>
            {userAccount?.map((userBank, index) => (
              <tr key={index}>
                <td style={{ paddingTop: "1rem" }}></td>
                <td style={{ paddingTop: "1rem" }}>{index + 1}</td>

                {/* =====================> Qr image <===================== */}
                <td style={{ paddingTop: "1rem" }}>
                  {isEdit === true && editIndex === index ? (
                    <div>
                      <input
                        type="file"
                        id="file-upload"
                        onChange={handleUpload}
                        hidden
                      />
                      <label htmlFor="file-upload">
                        {file ? (
                          <ImageThumb image={file} />
                        ) : (
                          <img
                            src={S3_URL + editData?.image ?? ""}
                            style={{
                              borderRadius: "10%",
                              cursor: "pointer",
                              height: 40,
                              width: 40,
                            }}
                          />
                        )}
                      </label>
                    </div>
                  ) : (
                    <div>
                      <img
                        src={S3_URL + userBank?.image}
                        style={{ height: "40px", borderRadius: "20%" }}
                      />
                    </div>
                  )}
                </td>
                {/* =====================> bank Name <===================== */}
                <td style={{ paddingTop: "1rem" }}>
                  {isEdit === true && editIndex === index ? (
                    <Form.Control
                      type="text"
                      name="bankName"
                      onChange={(e) => {
                        let _data = editData;
                        _data = {
                          ...editData,
                          bankName: e?.target?.value,
                        };
                        setEditData(_data);
                      }}
                      value={editData?.bankName}
                      placeholder="ຊື່ທະນາຄານ..."
                      style={{
                        border: editData?.bankName ? "" : "solid 1px red",
                      }}
                    />
                  ) : (
                    <div>{userBank?.bankName}</div>
                  )}
                </td>

                {/* =====================> bank Account <===================== */}

                <td style={{ paddingTop: "1rem" }}>
                  {isEdit === true && editIndex === index ? (
                    <Form.Control
                      type="text"
                      name="bankAccount"
                      onChange={(e) => {
                        let _data = editData;
                        _data = {
                          ...editData,
                          bankAccount: e?.target?.value,
                        };
                        setEditData(_data);
                      }}
                      value={editData?.bankAccount}
                      placeholder="ເລກບັນຊີ..."
                      style={{
                        border: editData?.bankAccount ? "" : "solid 1px red",
                      }}
                    />
                  ) : (
                    <div>{userBank?.bankAccount}</div>
                  )}
                </td>

                {/* =====================> bank User <===================== */}
                <td style={{ paddingTop: "1rem" }}>
                  {isEdit === true && editIndex === index ? (
                    <Form.Control
                      type="text"
                      name="bankUser"
                      onChange={(e) => {
                        let _data = editData;
                        _data = {
                          ...editData,
                          bankUser: e?.target?.value,
                        };
                        setEditData(_data);
                      }}
                      value={editData?.bankUser}
                      placeholder="ຊື່ບັນຊີ..."
                      style={{
                        border: editData?.bankUser ? "" : "solid 1px red",
                      }}
                    />
                  ) : (
                    <div>{userBank?.bankUser}</div>
                  )}
                </td>

                 {/* =====================> bank isActiveDefault <===================== */}
                <td style={{ paddingTop: "1rem" }}>
                  {isEdit && editIndex === index ? (
                    <Form.Check
                      type="checkbox"
                      name="isActiveDefault"
                      checked={!!editData?.isActiveDefault}
                      onChange={(e) => {
                        console.log("e.target.checked", e.target.checked);
                        setEditData(prev => ({
                          ...prev,
                          isActiveDefault: e.target.checked
                        }));
                      }}
                      className={editData?.isActiveDefault ? 'border-danger' : ''}
                    />
                  ) : (
                    <Form.Check
                      disabled
                      type="checkbox"
                      name="isActiveDefault"
                      checked={userBank?.isActiveDefault}
                      className={userBank?.isActiveDefault ? 'border-danger' : ''}
                    />
                  )}
                </td>

                {/* =====================> Button Update <===================== */}

                {isEdit === true && editIndex === index ? (
                  <td style={{ width: "30%" }}>
                    <div style={{ display: "flex" }}>
                      <CustomButton
                        width="149px"
                        height="42px"
                        color="#3058A6"
                        background="#F1F1F1"
                        borderRadius="8px"
                        title="ຍົກເລີກ"
                        onClick={() => onCancelEditData()}
                        disabled={loadingCreate || loadingUpdate || loadingDelete}
                      />
                      &ensp;
                      <CustomButton
                        width="149px"
                        height="42px"
                        borderRadius="8px"
                        title={loadingUpdate ? <Spinner /> : "ບັນທືກ"}
                        onClick={() => _updateBank()}
                        disabled={loadingCreate || loadingUpdate || loadingDelete}
                      />
                    </div>
                  </td>
                ) : (
                  <td style={{ width: "30%" }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <CustomButton
                        width="149px"
                        height="42px"
                        borderRadius="8px"
                        textalign="center"
                        border="1px solid #3C169B"
                        title="ເເກ້ໄຂ"
                        color="#3C169B"
                        background="#F7F7F7"
                        icon={
                          <EditIcon
                            style={{
                              color: "#3C169B",
                              fontSize: "20px",
                            }}
                          />
                        }
                        onClick={() => onEditData(userBank, index)}
                        disabled={loadingCreate || loadingUpdate || loadingDelete}
                      />
                      &ensp;
                      <CustomButton
                        width="149px"
                        height="42px"
                        margin="0"
                        title=" ລົບ"
                        border="1px solid #DC2626"
                        borderRadius="8px"
                        background="#F7F7F7"
                        color="#DC2626"
                        icon={
                          <DeleteIcon
                            style={{
                              color: "#D21C1C",
                              fontSize: "20px",
                            }}
                          />
                        }
                        onClick={() =>
                          handleShowDelete(userBank?.id, userBank?.bankAccount)
                        }
                        disabled={loadingCreate || loadingUpdate || loadingDelete}
                      />
                    </div>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </Table> : <div>
          {userAccount?.length <= 0 && <div style={{
            fontSize: "24px",
            display: 'flex',
            flexDirection: "column",
            justifyContent: "center",
            alignItems: 'center',
            // height: "100%",
            // background:"red",
            color: "#6B7280",
            fontWeight: "400"
          }}>
            <EmptyComponent />
            <p>ຍັງບໍ່ມີບັນຊີກະລຸນາໄປເພີ່ມບັນຊີກ່ອນ !!!</p>
          </div>}
        </div>

      }


      {/* Confirm Delete */}

      <ComfirmModal
        showConfirmModal={showDelete}
        handleCancel={() => setShowDelete(false)}
        handleConfirm={
          _confirmeDelete
        }
        title="ແຈ້ງເຕືອນ"
        text={
          `ທ່ານຕອ້ງການລົບຂໍ້ມູນ` + ` ${Delete?.bankAccount}` + ` ນີ້ເເທ້ບໍ່!`
        }
      />
      {/* Add Bank Modal */}
      <Modal show={showAddAccount} onHide={() => setShowAddAccount(false)}>
        <Modal.Header style={{ backgroundColor: "rgb(60, 22, 155)" }}>
          <Modal.Title style={{ margin: "0 auto", color: "#FFFFFF" }}>
            ເພີ່ມທະນາຄານ
          </Modal.Title>
        </Modal.Header>
        <Formik
          enableReinitialize={true}
          initialValues={{
            bankName: "",
            bankAccount: "",
            bankUser: "",
            image: "",
          }}
          validate={(values) => {
            const errors = {};

            if (!values.bankAccount) {
              errors.bankAccount = 'ກະລຸນາເພີ່ມເລກບັນຊີ...';
            } else if (values.bankAccount.length >= 19) {
              errors.bankAccount = 'ເລກບັນຊີຕ້ອງບໍ່ຫລາຍກວ່າ 18 ຕົວເລກ';
            }

            // Add other validation logic as needed

            return errors;
          }}
          onSubmit={async (values, { setSubmitting }) => {
            await _createBank(values);
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            /* and other goodies */
          }) => (
            <>
              {/* ---------- Modal Add------------ */}

              <Modal.Body>
                <Form.Label>ຊື່ທະນາຄານ</Form.Label>
                <Form.Control
                  type="text"
                  name="bankName"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.bankName}
                  placeholder={"ຊື່ທະນາຄານ..."}
                />

                <Form.Label>ເລກບັນຊີ</Form.Label>

                <Form.Control
                  type="test"
                  name="bankAccount"
                  onChange={(e) =>
                    handleChange(e)

                  }

                  onBlur={handleBlur}
                  value={values.bankAccount}
                  placeholder="ເລກບັນຊີ..."
                  style={{
                    border: errors.bankAccount && touched.bankAccount ? "solid 1px red" : "",
                  }}
                  maxLength={19}
                />
                {errors.bankAccount && touched.bankAccount && (
                  <div style={{ color: "red", marginTop: "5px" }}>
                    {errors.bankAccount}
                  </div>
                )}



                <Form.Label>ຊື່ບັນຊີ</Form.Label>
                <Form.Control
                  type="text"
                  name="bankUser"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.bankUser}
                  placeholder="ຊື່ບັນຊີ..."
                />
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: "10px",
                  }}
                >
                  <div style={{ textAlign: "center" }}>
                    <input
                      type="file"
                      id="file-upload"
                      onChange={handleUpload}
                      hidden
                    />
                    <label htmlFor="file-upload">
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          backgroundColor: "#f2f2f2",
                          height: "150px",
                          width: "150px",
                          borderRadius: "5%",
                          cursor: "pointer",
                        }}
                      >
                        {file ? (
                          <ImageThumb image={file} />
                        ) : (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              height: "100%",
                              width: "100%",
                              fontSize: "20px",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            {/* <CloudUploadOutlinedIcon sx={{ fontSize: "100px", color: '#93989F' }} />
                                                        <p style={{ color: '#93989F' }}>ເພີ່ມຮູບສິ້ນຄ້າ</p>
                                                        <p style={{ color: '#3C169B', textDecoration: "underline" }}>Browse</p> */}
                            <AddCircleOutlineIcon
                              style={{
                                color: "#ffffff",
                                fontSize: "80px",
                              }}
                            />
                          </div>
                        )}
                      </div>
                    </label>
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <CustomButton
                  title="ຍົກເລີກ"
                  width="100px"
                  background="#A9B3BD"
                  borderRadius="8px"
                  onClick={() => setShowAddAccount(false)}
                />
                &emsp;
                <CustomButton
                  title={loadingCreate ? <Spinner /> : "ບັນທຶກ"}
                  width="100px"
                  borderRadius="8px"
                  onClick={() => handleSubmit()}
                />
              </Modal.Footer>
            </>
          )}
        </Formik>
      </Modal>

      {/* End of Add Bank Account Modal */}
    </div>
  );
}

export default BankAccount;
